/* eslint-disable no-undef */
export const setPageTitle = (title: string) => {
  const baseTitle = 'ConsultSRE';
  document.title = title ? `${baseTitle} | ${title}` : baseTitle;
};

export const PAGE_TITLES = {
  HOME: 'Enterprise SRE & DevOps Consulting for High-Growth Companies',
  SERVICES: 'Expert SRE & DevOps Solutions for Scale',
  BLOG: 'Insights & Best Practices in SRE',
  CONTACT: 'Get in Touch with Our Experts',
  LOGIN: 'Admin Login',
  ADMIN: 'Admin Dashboard',
  NOT_FOUND: 'Page Not Found',
} as const;
/* eslint-enable no-undef */ 